export default __webpack_public_path__ + "static/automobile-video-billboard-a1c43dd1d82f69437a951286e985ac2c.gif";